"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayOfType = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ArrayOfType = ({ type, minSize = 0, maxSize = -1, }) => (target, property) => {
    (0, class_transformer_1.Type)(type)(target, property);
    (0, class_validator_1.ValidateNested)({ each: true })(target, property);
    (0, class_validator_1.IsArray)()(target, property);
    (0, class_validator_1.ArrayMinSize)(minSize)(target, property);
    if (minSize > 0) {
        (0, class_validator_1.ArrayNotEmpty)()(target, property);
    }
    if (maxSize > -1) {
        (0, class_validator_1.ArrayMaxSize)(maxSize)(target, property);
    }
};
exports.ArrayOfType = ArrayOfType;
